import React from "react";
import { PracticeUsersIndex } from "../user";

export default function Index(props) {
  return <PracticeUsersIndex {...props} isAdmin />;
}
